import colors from '../theme/colors';
import palette from '../theme/palette';

const variants = [
  {
    props: { color: 'internal' },
    style: {
      color: `${palette.internal.main} !important`,
      '&:hover': {
        color: `${colors.internal['700']} !important`,
      },
    },
  },
  {
    props: { subMenu: 'desktop' },
    style: {
      width: 'calc(100% - 1px)',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      textAlign: 'left',
      minHeight: '56px',
      marginLeft: 0,
      marginRight: 0,
      padding: '16px',
      '&.MuiButtonBase-root.MuiTab-root': {
        minHeight: '48px',
        fontSize: '1.15em',
      },
      '& > *:first-of-type': {
        marginRight: '16px',
        marginLeft: '4px',
      },
      '&.Mui-selected': {
        background: palette.common.white,
      },
    },
  },
  {
    props: { subMenu: 'mobile' },
    style: {
      border: '2px solid',
      borderRadius: '8px',
      marginRight: '8px',
      width: '140px',
      padding: '8px',
      justifyContent: 'flex-start',
      // border color here
      '&.Mui-selected': {
        background: palette.common.white,
      },
    },
  },
  {
    props: { textColor: 'primary' },
    style: {
      color: palette.text.primary,
    },
  },
];

export default variants;
